import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { environment } from '../../environments/environment';

import { UserService } from './api/user.service';

@Injectable()
export class OauthCheck implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  canActivate() {

    this.router.navigate(['']);
    return false;
  }


}




// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/common/oauth.check.ts